export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./index.vue?vue&type=template&id=f978d064&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/pages/lk/events/index.vue?vue&type=template&id=f978d064&
// module id = 1119
// module chunks = 0